import { withSpace } from "./redux-spaces";

export default (spaces) => withSpace(spaces);
